// :cow: Cosmose CONFIDENTIAL :iso:
import { Action } from '@ngrx/store';
import { AssetPackage } from '@med/app/home/campaign/modules/execution/model/asset.model';

export const SET_ASSET_PACKAGES = '[Execution] Set asset packages';
export const ADD_ASSET_PACKAGE = '[Execution] Add asset package';
export const DELETE_ASSET_PACKAGE = '[Execution] Delete asset package';
export const UPDATE_ASSET_PACKAGE = '[Execution] Update asset package';
export const EXECUTION_NAV_PREVIOUS_STEP_TRIGGERED = '[Execution] Trigger previous step';
export const EXECUTION_NAV_NEXT_STEP_TRIGGERED = '[Execution] Trigger next step';
export const EXECUTION_NAV_REVIEW_TRIGGERED = '[Execution] Trigger next step';

export class TriggerNextStep implements Action {
  readonly type = EXECUTION_NAV_NEXT_STEP_TRIGGERED;
}

export class TriggerPreviousStep implements Action {
  readonly type = EXECUTION_NAV_PREVIOUS_STEP_TRIGGERED;
}

export class TriggerReview implements Action {
  readonly type = EXECUTION_NAV_REVIEW_TRIGGERED;
}

export class SetAssetPackages implements Action {
  readonly type = SET_ASSET_PACKAGES;

  constructor(public payload: { assetPackages: AssetPackage[] }) {
  }
}

export class AddAssetPackage implements Action {
  readonly type = ADD_ASSET_PACKAGE;

  constructor(public payload: { assetPackage: AssetPackage }) {
  }
}

export class UpdateAssetPackage implements Action {
  readonly type = UPDATE_ASSET_PACKAGE;

  constructor(public payload: { assetPackage: AssetPackage }) {
  }
}

export class DeleteAssetPackage implements Action {
  readonly type = DELETE_ASSET_PACKAGE;

  constructor(public payload: { assetPackageId: string }) {
  }
}

export type All = SetAssetPackages
  | TriggerPreviousStep
  | TriggerNextStep
  | TriggerReview
  | AddAssetPackage
  | UpdateAssetPackage
  | DeleteAssetPackage;
